import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  httpOptions:any;
  headers:any;

  constructor(private http:HttpClient) 
    {
      
     
    }

    postStudentFile(url,param){
      return this.http.post(url,param)
    }
    postMarksFile(url,param){
      return this.http.post(url,param)
    }

    
}
